import React, { useState } from 'react';
import { auth } from './firebaseConfig';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import './index.css';

const Auth = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleLogin = async () => {
        try {
            await signInWithEmailAndPassword(auth, email, password);
            setError('');
            navigate('/dashboard');
        } catch (error) {
            console.error('Login error:', error.message);
            setError(error.message);
        }
    };

    const handleResetPassword = async () => {
        if (!email) {
            setError('Please enter your email address first.');
            return;
        }

        try {
            await sendPasswordResetEmail(auth, email);
            setError('');
            alert('📧 Password reset email sent. Check your inbox.');
        } catch (error) {
            console.error('Reset Error:', error.message);
            setError('Failed to send password reset email. Please try again.');
        }
    };

    return (
        <div className="login-wrapper">
            <div className="login-box">
                <h2>🔐 Login to TrackSmart Solutions</h2>
                {error && <p className="error-message">{error}</p>}
                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <div className="auth-buttons">
                    <button onClick={handleLogin}>Log In</button>
                    <button onClick={handleResetPassword} type="button" className="forgot-btn">
                        Forgot Password?
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Auth;